import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, WhatsappLogo } from "@phosphor-icons/react";
import logoIcon from "../../assets/logo-icon.png";
import StartShapes from "./StartShapes";
import { FOOTER, PROFESSIONS, getWhatsAppHref } from "../../data/startPageContent";
import "./StartFooter.css";

const FOR_LINKS = PROFESSIONS.filter(
  (p, i, arr) => p.slug && arr.findIndex((q) => q.slug === p.slug) === i
);

/** Footer (plan §4.10): dark band — brand + CTA, professions, nav + legal. */
export default function StartFooter() {
  return (
    <footer className="st-footer st-dark">
      <StartShapes prefix="st-footer" kinds={["blob", "dot", "square"]} />
      <div className="st-container">
        <div className="st-footer-grid">
          <div className="st-footer-brand">
            <Link to="/" className="st-footer-logo" aria-label="CliniKit">
              <img src={logoIcon} alt="" className="st-footer-logo-icon" width="32" height="32" />
              <span className="st-footer-logo-text">CliniKit</span>
            </Link>
            <p className="st-footer-tagline">{FOOTER.tagline}</p>
            <div className="st-footer-actions">
              <a href="#start-form" className="st-btn st-btn--primary st-footer-cta">
                {FOOTER.cta}
                <ArrowLeft size={18} weight="bold" />
              </a>
              <a
                href={getWhatsAppHref()}
                target="_blank"
                rel="noopener noreferrer"
                className="st-footer-wa"
              >
                <WhatsappLogo size={20} weight="fill" />
                {FOOTER.waLabel}
              </a>
            </div>
          </div>

          <nav className="st-footer-col st-footer-for" aria-label={FOOTER.forLinksTitle}>
            <span className="st-footer-col-title">{FOOTER.forLinksTitle}</span>
            <ul className="st-footer-list st-footer-list--cols">
              {FOR_LINKS.map((p) => (
                <li key={p.slug}>
                  <Link to={`/for/${p.slug}`}>{p.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="st-footer-col">
            <nav aria-label={FOOTER.navTitle}>
              <span className="st-footer-col-title">{FOOTER.navTitle}</span>
              <ul className="st-footer-list">
                {FOOTER.nav.map((l) => (
                  <li key={l.href}>
                    <a href={l.href}>{l.label}</a>
                  </li>
                ))}
              </ul>
            </nav>
            <nav aria-label={FOOTER.legalTitle} className="st-footer-legal-col">
              <span className="st-footer-col-title">{FOOTER.legalTitle}</span>
              <ul className="st-footer-list">
                {FOOTER.links.map((l) => (
                  <li key={l.href}>
                    <Link to={l.href}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        <div className="st-footer-bottom">
          <span className="st-footer-copy">© {new Date().getFullYear()} CliniKit · כל הזכויות שמורות</span>
          <Link to="/login" className="st-footer-login">כניסה למערכת</Link>
        </div>
      </div>
    </footer>
  );
}
